import { isSyncStorageDriver } from './syncStorageDriver';

/**
 * @param {() => Storage} getStorage
 * @returns {import('./syncStorageDriver').SyncStorageDriver}
 */
export function createBrowserStorageDriver(getStorage) {
  if (typeof getStorage !== 'function') {
    throw new Error('createBrowserStorageDriver requires a getStorage factory');
  }

  const driver = {
    getItem(key) {
      return getStorage().getItem(key);
    },
    setItem(key, value) {
      getStorage().setItem(key, value);
    },
    removeItem(key) {
      getStorage().removeItem(key);
    },
  };

  if (!isSyncStorageDriver(driver)) {
    throw new Error('Browser storage driver failed contract validation');
  }

  return driver;
}

/**
 * Lazy browser localStorage accessor for future caller migration phases.
 * Not imported by production code in P-1B.
 *
 * @returns {import('./syncStorageDriver').SyncStorageDriver}
 */
export function createDefaultBrowserStorageDriver() {
  return createBrowserStorageDriver(() => {
    if (typeof window === 'undefined' || !window.localStorage) {
      throw new Error('localStorage is unavailable');
    }
    return window.localStorage;
  });
}
